export const roundLatLng = (latLng, precision) => {
    if (!latLng) return undefined;
    return {
        lat: parseFloat(latLng.lat().toFixed(precision || 6)),
        lng: parseFloat(latLng.lng().toFixed(precision || 6)),
    };
};
